
<template>

<el-row>
    <el-col :span="18">

        <el-form :model="productForm" addAction="lcwpgoods/insertSecondHandCar.action" selectAction="lcwpgoods/selectSecondHandCar.action" editAction="lcwpgoods/editSecondHandCar.action"  v-form :rules="rules" ref="ruleForm" label-width="150px">

          <el-form-item label="选择车系" v-if="productForm.type=='新车' || productForm.type=='二手车'"  prop="seriesId" :rules="[{ required: !productForm.id, message: '车系不能为空'}]">
              <p>{{productForm.brand}} {{productForm.series}} {{productForm.category}} {{productForm.officePrice/10000}}万</p>
              <brand-and-series-categories-select  brandPlaceholder="品牌（单选）" seriesPlaceholder="车系（单选）" categoriesPlaceholder="车型（单选）" :categoriesMultiple="false" ref="brand-and-series-select" @onChanged="carCategoryChange"></brand-and-series-categories-select>
          </el-form-item>

         <!-- <el-form-item label="车身颜色" prop="color">
              <el-input   v-model="productForm.color" placeholder="请填写（1-10个字）"></el-input>
          </el-form-item>-->

          <el-form-item label="上牌地点" prop="licenseAddress" >

              <search-area-input ref="business-address" v-model="productForm.licenseAddress" placeholder="请选择（支持搜索联想输入）" :defaultValue="productForm.licenseAddress" @onChenged="onLicenseAddressChanged"></search-area-input>

          </el-form-item>

          <el-form-item label="上次上牌时间" prop="licenseTime">
            <el-date-picker
              v-model="productForm.licenseTime"
              type="date"
              placeholder="选择上次上牌时间">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="行驶里程" prop="mileage">
              <el-input   v-model="productForm.mileage" type="number" placeholder="请填写0.01-1000之间的数值（单位万公里）"></el-input>
          </el-form-item>

            <el-form-item label="联系电话" prop="phone">
                <el-input   v-model="productForm.phone"   placeholder="联系手机号"></el-input>
            </el-form-item>

          <!-- <el-form-item label="车辆照片" prop="photo">
            <el-upload
                multiple
                ref="photo"
                accept="image/*"
                action="upload/uploadPic"
                v-model="productForm.photo"
                :before-upload="beforeAvatarUpload"
                :data="{floder:'plusBusiness'}"
                list-type="picture-card"
                :limit="9"
                :file-list="productForm.photo">
                <i class="el-icon-plus"></i>
            </el-upload>
            <p style="color:#666;">尺寸：750*460px<span style="color:red;">选择品牌车系后，将自动填充9张新车照片；自传尺寸：750*460px，最多9张</span></p>
          </el-form-item> -->

            <el-form-item label="车辆图片：" prop="photo">
                <draggable v-model="productForm.photo" tag="ul" class="img-temp-list" draggable=".img-temp-item">
                    <li class="img-temp-item" v-for="(item, i) in productForm.photo" :key="i">
                        <img :src="item.url" />
                        <div class="img-action">
                            <el-image  style="width: 20px; height: 20px"  alt="" :src="baseImageUrl+baseSmalIcon" :preview-src-list="[item.url]"></el-image>
                            <i class="el-icon-delete" @click="removeFile(productForm.photo,i)"></i>
                        </div>
                    </li>
                    <el-upload
                            :show-file-list="false"
                            :before-upload="beforeAvatarUpload"
                            :data="{floder:'plusBusiness'}"
                            :file-list="productForm.photo"
                            :http-request="onHttpRequest"
                            :limit="9"
                            accept="image/*"
                            action="upload/uploadPic"
                            list-type="picture-card"
                            multiple
                            ref="photo"
                            v-model="productForm.photo">

                        <i class="el-icon-plus"></i>
                    </el-upload>

                </draggable>
                <p style="color:#666;"><span style="color:red;">自传尺寸：750 * 460像素的，最多9张</span></p>
            </el-form-item>

          <el-form-item label="车辆售价" prop="currentPrice">
              <el-input type="number"  v-model="productForm.currentPrice" placeholder="请填写100-10000000之间的整数（单位元）"></el-input>
                <p style="color:#666;"><span style="color:red;">提示：车辆售价仅作展示使用，不作为最终成交依据！</span></p>
          </el-form-item>
<!--
          <el-form-item label="是否包含过户费" prop="isTransferFee" >
            <el-switch
              v-model="productForm.isTransferFee"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="包含"
              :active-value="1"
              inactive-text="不包含"
              :inactive-value="2">
            </el-switch>
          </el-form-item>-->

          <el-form-item label="保险到期时间" prop="insuranceExpirationDate">
            <el-date-picker
              v-model="productForm.insuranceExpirationDate"
              type="date"
              placeholder="请选择（选填）">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="年检到期时间" prop="inspectionExpirationDate">
            <el-date-picker
              v-model="productForm.inspectionExpirationDate"
              type="date"
              placeholder="请选择（选填）">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="车辆描述" prop="goodsDesc">
              <el-input v-model="productForm.goodsDesc" type="textarea" placeholder="选填 比如：车辆碰撞，外观描述等（建议300字以内）"></el-input>
          </el-form-item>

            <el-form-item>
                <el-button type="primary">确定发布</el-button>
            </el-form-item>

        </el-form>

    </el-col>
</el-row>

</template>

<script>
import cityCascader from '@/components/cityCascader'
import ChannelModel from '@/framework/models/channelModel'
import BrandAndSeriesCategoriesSelect from '@/components/BrandAndSeriesCategoriesSelect'
import BasicPager from '../../../mixins/BasicPager'
import Config from '@/framework/configs/Config'
import SearchAreaInput from '@/components/SearchAreaInput'
export default {
  name: 'add-plus-second-handCar',
  extends: BasicPager,
  data: function () {
    var checkPrice = (rule, value, callback) => {
      if (value < 100 || value > 10000000) {
        return callback(new Error('请填写100-10000000之间的整数（单位元）'))
      }
      callback()
    }

    var checkMileage = (rule, value, callback) => {
      if (value < 0.01 || value > 1000) {
        return callback(new Error('请填写0.01-1000之间的数值（单位万公里）'))
      }

      let match = value + ''.match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        callback(new Error('小数点只能保留两位哦！'))
      }

      callback()
    }

    return {
      baseSmalIcon: 'ClueDistribution/fdjxtb.png',
      tips: '提示：该类商品只用于发布后展示，暂不支持用户直接线上下单支付',
      placeholder: '比如：埃尔法热销中 目前售价77.2万元起；近日，本店内有埃尔法销售，颜色可选，目前购车部分车型可优惠6.8万元，感兴趣的朋友可以到店咨询购买',
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      productForm: {
        type: '新车',
        productInfo: null,
        seriesId: null,
        brandId: null,
        seriesName: null,
        productName: null,
        priceInfo: null,
        photo: [],
        businessId: null,
        currentPrice: null,
        licenseAddress: null,
        phone: null
      },
      rules: {
        goodsName: [{
          required: true,
          message: '商品名称不能为空'
        }
        ],
        phone: [{
          required: true,
          message: '手机号不能为空'
        }
        ],
        licenseAddress: [{
          required: true,
          message: '上牌地点不能为空',
          trigger: 'change'
        }],
        licenseTime: [{
          required: true,
          message: '上牌时间不能为空'
        }
        ],
        mileage: [{
          required: true,
          message: '行驶里程不能为空'
        },
        {
          validator: checkMileage, trigger: 'blur'
        }
        ],
        currentPrice: [{
          required: true,
          message: '车辆售价不能为空'
        },
        {
          validator: checkPrice, trigger: 'blur'
        }
        ],
        goodsDesc: [{
          required: false,
          message: '卖点或活动说明不能为空'
        }],
        photo: [
          {
            required: true,
            message: '商品图片不能为空！',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    'productForm.productType': function (productType) {
      this.productForm.brandId = null
      this.productForm.seriesId = null
      this.productForm.seriesName = null
      this.productForm.productName = null
      this.productForm.photo = []
      this.$refs['brand-and-series-select'].clear()
    }
  },
  components: {
    BrandAndSeriesCategoriesSelect,
    cityCascader,
    SearchAreaInput
  },
  created: function () {
    let params = this.$route.params

    this.productForm.id = params.goodsId
    // let businessProductId = parseInt(params.businessProductId)
    // this.productForm.id = businessProductId
    if (params.businessId) {
      let businessId = parseInt(params.businessId)
      this.productForm.businessId = businessId
    }

    if (params.carShowId) {
      this.productForm.carShowId = params.carShowId
    }
  },
  methods: {
    onLicenseAddressChanged: function (addressInfo) {
      let city = addressInfo.province + ' ' + addressInfo.city
      this.productForm.licenseAddress = city
      // this.$set(this.productForm,'licenseAddress',labels.join(' '))
    },
    onTypeChange: function () {
      this.productForm.photo = []
    },
    carCategoryChange: function (brandInfo, seriesInfo, categoriesInfo) {
      //  String goodsName, String goodsDesc,Integer currentPrice,String officePrice,Integer brandId,Integer seriesId,String categoryIds,
      //                                            String brand,String series,String photo,@RequestAttribute Integer businessId
      // 商品名
      this.productForm.goodsName = brandInfo.name + ' ' + seriesInfo.name + ' ' + categoriesInfo.name

      // 官方指定价
      this.productForm.officePrice = categoriesInfo.price

      // 品牌车系车型
      this.productForm.brandId = brandInfo.id
      this.productForm.brand = brandInfo.name
      this.productForm.seriesId = seriesInfo.id
      this.productForm.series = seriesInfo.name

      this.productForm.categoryId = categoriesInfo.id
      this.productForm.category = categoriesInfo.name

      // let categoryIds =  []
      // for (var i = 0; i < categoriesInfo.length; i++) {
      //   let item = categoriesInfo[i]
      //   categoryIds.push(item.id)
      // }
      // this.productForm.categoryIds = categoryIds.join(',')

      // 添加照片
      // this.productForm.photo = []
      //
      // if(this.productForm.type== '新车'){
      //   let name = seriesInfo.imgUrl.replace('https://csz-test.oss-cn-hangzhou.aliyuncs.com/', '').replace('https://csz-public.oss-cn-hangzhou.aliyuncs.com/', '');
      //   this.productForm.photo.push({
      //       name: name,
      //       url: seriesInfo.imgUrl
      //   })
      //
      //   if (!seriesInfo) {
      //       this.productForm.photo = []
      //       return;
      //       return;
      //   }
      // }
    },
    removeFile (list, index) {
      list.splice(index, 1)
    },
    beforeAvatarUpload (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 15
        if (!isLt5M) {
          _this.$message.error('上传图片大小不能超过 15MB!')
          reject(new Error('上传图片大小不能超过 15MB!'))
          return
        }

        if (_this.productForm.photo.length >= 9) {
          _this.$message.error('最多只能上传9张!')
          reject(new Error('最多只能上传9张!'))
          return
        }
        resolve()
      })
      return promise
    },
    findAllChannels: function (channelName) {
      let _this = this

      let listener = {
        success: function (dataInfo) {
          _this.components[2].prop.options = dataInfo.datas
        }
      }
      ChannelModel.findAllChannels(_this, listener)
    },
    onFilterParams: function (params) {
      params.currentPrice = parseInt(params.currentPrice * 100)

      // 只保留省市
      let licenseAddress = params.licenseAddress
      if (licenseAddress) {
        let addr = licenseAddress.split(' ')
        if (addr && addr.length === 3) {
          params.licenseAddress = addr[0] + ' ' + addr[1]
        }
      }
    },
    onSelectInfo: function (dataInfo) {
      this.productForm.currentPrice = Number(dataInfo.datas.currentPrice / 100).valueOf()

      let brandAndSeriesSelect = this.$refs['brand-and-series-select']
      if (brandAndSeriesSelect) {
        brandAndSeriesSelect.setValue(dataInfo.datas.brandId, dataInfo.datas.seriesId, dataInfo.datas.categoryId)
      }
    }
  }
}

</script>

<style scoped>

    .img-temp-list {
        padding-left: 0;
        display: flex;
        align-items: center;
        flex-warp: warp;
    }

    .img-temp-item {
        overflow: hidden;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        margin: 0 8px 8px 0;
        display: inline-block;
        position: relative;
    }

    .img-temp-item img {
        width: 100%;
        height: 100%;
    }
    .img-temp-item:hover .img-action {
        opacity: 1;
    }

    .img-temp-item .img-action {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        opacity: 0;
    }
    .img-action i {
        font-size: 20px;
        color: #fff;
        margin-left: 15px;
        cursor: pointer;
    }
    .img-action i:first-child {
        margin-left: 0;
    }
</style>
